// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { ACCOUNT_ID, KEY_HAS_NAVIGATED_FROM_LINK } from '../../../common/constants.tsx';
import { localStorageProvider } from '../../../common/utils/local-storage.tsx';
import type { State } from '../../model/types.tsx';
import { getNextNonCompleteTask } from '../../utils.tsx';
import { nextAutoOpenTask } from '../next-open-task/index.tsx';

export const nextAutoExpand =
	() =>
	({ getState, dispatch }: StoreActionApi<State>) => {
		const hasNudgeToShowAfterNavigation = localStorageProvider().get({
			accountId: ACCOUNT_ID,
			key: KEY_HAS_NAVIGATED_FROM_LINK,
		});
		if (hasNudgeToShowAfterNavigation) {
			return;
		}

		const { openTask, completedTaskList, tasks } = getState();

		if (!tasks) {
			return;
		}
		const { items } = tasks;

		if (
			// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
			items.includes(openTask) &&
			// @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
			!completedTaskList.includes(openTask)
		) {
			return;
		}

		const taskIdToExpand = getNextNonCompleteTask(items, completedTaskList, openTask);
		if (taskIdToExpand === null) {
			return;
		}

		dispatch(nextAutoOpenTask(taskIdToExpand));
	};
